import { actions } from "./state";

export const changeRawatJalan = (props) => {
  return {
    type: actions.CHANGE_RAWAT_JALAN,
    payload: props,
  };
};

export const changeLoading = (props) => {
  return {
    type: actions.CHANGE_LOADING,
    payload: props,
  };
};

export const changeAntreanJkn = (props) => {
  return {
    type: actions.CHANGE_ANTREAN_JKN,
    payload: props,
  };
};

export const changeLoadingJkn = (props) => {
  return {
    type: actions.CHANGE_LOADING_ANTREAN_JKN,
    payload: props,
  };
};
